// extracted by mini-css-extract-plugin
export default {"cls1":"LnEdsCGJp79ALueC55D1","cls2":"wkaTQ118dDb40uVNvqg9 LnEdsCGJp79ALueC55D1","isPhone":"vhiYh0KnLDDQngXjk4yQ"};